import styled from 'styled-components';

export const NavPill = styled.div``;

export const NavPillLink = styled.div`
  /* Adapt the colors based on active prop */
  background-color: inherit;
  border-bottom: ${props => (props.active ? '3px #C6D92D solid' : '')};
`;
